import React from "react";
import SupportCard from "../../../library/custom/supportCard/supportCard";
import "./connectStyle.scss";
import PlagiarismIcon from "@mui/icons-material/Plagiarism";
import { Grid } from "@mui/material";
import commonImages from "../../../assets";
import BackBtn from "../../../library/custom/backBtn/backBtn";

const Connect = () => {
  const dataBack = {
    title: "Back",
    route: -1,
  };
  return (
    <div className="overrideConnect">
      <div className="connectMainContainer">
        <div className="rightContainer">
          <Grid container gap={3} className="cardsContainer">
            <SupportCard
              className="card"
              icon={
                <div className="iconShow">
                  <img
                    className="light"
                    src={commonImages?.supportConnectCallIcon}
                    alt=""
                  />{" "}
                  <img
                    className="dark"
                    src={commonImages?.supportConnectCallIconDark}
                    alt=""
                  />
                </div>
              }
              category="Phone"
              details="770-619-1669"
              details2="(M-F: 8:00am - 5:00pm)"
            />
            <SupportCard
              className="card"
              icon={
                <div className="iconShow">
                  <img
                    className="light"
                    src={commonImages?.supportConnectAddressIcon}
                    alt=""
                  />{" "}
                  <img
                    className="dark"
                    src={commonImages?.supportConnectAddressIconDark}
                    alt=""
                  />
                </div>
              }
              category="Address"
              details="1255 Lakes Pkwy Suite 385,"
              details2=" Lawrenceville, GA 30043"
            />
            <SupportCard
              className="card"
              icon={
                <div className="iconShow">
                  <img
                    className="light"
                    src={commonImages?.supportConnectEmailIcon}
                    alt=""
                  />{" "}
                  <img
                    className="dark"
                    src={commonImages?.supportConnectEmailIconDark}
                    alt=""
                  />
                </div>
              }
              category="Email"
              details="support@nextsequence.io"
            />
          </Grid>
        </div>
      </div>
      <div>
        <BackBtn dataBack={dataBack} className="equipmentBack" />
      </div>
    </div>
  );
};

export default Connect;
